var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoursePublishStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.995,
    height: 40,
    viewBox: "0 0 39.995 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(-647.924 -586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1250308_bible_book_education_knowledge_learning_icon",
    "data-name": "1250308_bible_book_education_knowledge_learning_icon",
    transform: "translate(640.556 548.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(16 43.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0.556 0.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M39.5,80.318v-.611a.045.045,0,0,1,.062-.043l5.048,1.93a.04.04,0,0,0,.033,0l5.048-1.93a.045.045,0,0,1,.062.043v.611",
    transform: "translate(-39.5 -79.661)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(1.139 0.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M64.1,59.328v-.623a.046.046,0,0,1,.069-.04l4.454,2.415a.051.051,0,0,0,.045,0l4.452-2.418a.046.046,0,0,1,.069.04v.625",
    transform: "translate(-64.1 -58.657)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(1.792 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M91.7,43.7v-.613a.046.046,0,0,1,.073-.038l3.789,2.778a.046.046,0,0,0,.054,0l3.789-2.778a.047.047,0,0,1,.073.038v.618",
    transform: "translate(-91.7 -43.042)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M261.647,109.837l-5.6,1.387a.036.036,0,0,1-.045-.035v-7.215a.046.046,0,0,1,.035-.045l5.591-1.385a.046.046,0,0,1,.057.045v7.2A.046.046,0,0,1,261.647,109.837Z",
    transform: "translate(-250.317 -101.134)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M21.647,111.227l-5.612-1.39a.046.046,0,0,1-.035-.045v-7.2a.046.046,0,0,1,.057-.045l5.591,1.385a.046.046,0,0,1,.035.045V111.2a.027.027,0,0,1-.035.028Z",
    transform: "translate(-16 -101.134)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(23.326 49.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M327.981,328.326l-2.524.6a.046.046,0,0,1-.057-.045V327.59a.046.046,0,0,1,.035-.045l2.524-.6a.046.046,0,0,1,.057.045v1.293a.046.046,0,0,1-.035.045Z",
    transform: "translate(-325.4 -326.942)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0.002 0.465)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y1: 0.625,
    x2: 2.614,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 0.623,
    x2: 2.614,
    transform: "translate(0 0.433)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(644.924 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(3 202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "publishing",
    d: "M37.77,4.853H34.337V.607A.608.608,0,0,0,33.731,0H6.261a.608.608,0,0,0-.6.607V4.853H2.222A2.224,2.224,0,0,0,0,7.071V32.93a2.225,2.225,0,0,0,2.222,2.222h9.9v3.635H7.879a.607.607,0,0,0,0,1.213H32.121a.607.607,0,0,0,0-1.213H27.874v-3.64h9.9A2.225,2.225,0,0,0,40,32.93V7.071A2.224,2.224,0,0,0,37.77,4.853Zm-30.9-3.64H33.124V29.087H6.867ZM1.213,7.071a1.011,1.011,0,0,1,1.01-1.01H5.662V29.087H1.213ZM26.67,38.783H13.331V35.147H26.661ZM38.788,32.93a1.01,1.01,0,0,1-1.01,1.01H2.222a1.01,1.01,0,0,1-1.009-1.01V30.3H38.78Zm0-3.838H34.337V6.06H37.77a1.011,1.011,0,0,1,1.01,1.011ZM29.695,12.2H21.607a.607.607,0,1,1,0-1.213h8.088a.607.607,0,0,1,0,1.21Zm-8.088,4.525a.607.607,0,1,1,0-1.213h5.662a.607.607,0,0,1,0,1.213Zm8.088,4.524H18.315a.607.607,0,1,1,0-1.213h11.38a.607.607,0,0,1,0,1.213ZM10.3,20.036h4.782a.607.607,0,0,1,0,1.213H10.31a.607.607,0,0,1-.009-1.213Zm16.968,5.737h-4.64a.607.607,0,0,1,0-1.211h4.646a.607.607,0,0,1-.007,1.211Zm-7.878,0H10.3a.607.607,0,0,1,0-1.211h9.089a.607.607,0,0,1,0,1.211Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(676 593)",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursePublishStatus);
export default __webpack_public_path__ + "static/media/course-publish-status.6673dbd4479eeefcd00c61a80c789bb3.svg";
export { ForwardRef as ReactComponent };